var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative w-full h-[20.83vw]"},[_c('el-image',{staticClass:"w-full h-full",staticStyle:{"object-position":"center"},attrs:{"src":_vm.backgroundImage,"lazy":"","fit":"cover"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }